import api from 'service/api'

const dponetAPI = api.create('dponet')

const list = async (params) => {
  return await dponetAPI.get('/matrix_risks', { params })
}

const matrixRisk = { list }

export default matrixRisk
